export interface SelectOption {
  value: any;
  label: string;
  selected: boolean;
}
